var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgActivityScore(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.193 3.104a1 1 0 011.614 0l2.647 3.62a1 1 0 00.496.36l4.261 1.4a1 1 0 01.499 1.535l-2.625 3.636a1 1 0 00-.19.583l-.013 4.485a1 1 0 01-1.306.949l-4.27-1.373a1 1 0 00-.612 0l-4.27 1.373a1 1 0 01-1.306-.95l-.014-4.484a1 1 0 00-.189-.583L3.29 10.02a1 1 0 01.499-1.536L8.05 7.084a1 1 0 00.495-.36l2.648-3.62z",
    fill: "#6244FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.375 14.6v-4.326l.707.672h-1.547V9.7h2.492v4.9h-1.652zM9.32 13.87v-2.94h1.08v2.94H9.32zm-.99-.96v-1.02h3.06v1.02H8.33z",
    fill: "#fff"
  })));
}

export default SvgActivityScore;